import {useStaticQuery, graphql} from 'gatsby';

import {Locale} from '../../RootProvider/LocaleContext';

import {removeTrailingSlash} from './formatting';

export interface PageContext {
  locale: Locale;
  isAuthManagementPage: boolean;
}
export interface PageObject {
  path: string;
  context: PageContext;
}

export interface AllSitesPages {
  allSitePage: {
    nodes: PageObject[];
  };
}

export const useAllPagesData = (): PageObject[] => {
  // when we run storybook, we don't want this query to run as it breaks _everything_
  // this is a bit of a hack, but works for now
  if (process.env.STORYBOOK_BUILD) {
    return [];
  }

  // rule turned off because of above logic
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {allSitePage} = useStaticQuery<AllSitesPages>(
    graphql`
      query AllPaths {
        allSitePage {
          nodes {
            path
            context {
              locale
              isAuthManagementPage
            }
          }
        }
      }
    `
  );

  return allSitePage.nodes;
};

export const assertPathMatch = (path: string, checklist: string[]): boolean => {
  const pathSplit = path.split('/');

  return checklist.some((check) => {
    // allow any in param portions
    if (check.includes('[')) {
      const checkSplit = check.split('/');

      // different length means no match
      if (checkSplit.length !== pathSplit.length) {
        return false;
      }

      // check each portion matches
      return checkSplit.every((portion, index) => {
        // is url param so match anything
        if (portion.startsWith('[')) {
          return true;
        }
        return portion === pathSplit[index];
      });
    }

    return path === check;
  });
};

export const validatePhoenixURL = (href: string, allPageNodes: PageObject[]): boolean => {
  // flatten paths data from json and remove trailing slashes
  const phoenixPaths = allPageNodes.map(({path}) => removeTrailingSlash(path));
  // split out host portion
  const pathNoHost = href.startsWith('/') ? href : href.split('.com')[1];
  const pathNoAnchor = pathNoHost.includes('#') ? pathNoHost.split('#')[0] : pathNoHost;
  const path = removeTrailingSlash(pathNoAnchor);

  return assertPathMatch(path, phoenixPaths);
};
